(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ml-tic-tac-toe"] = factory();
	else
		root["ml-tic-tac-toe"] = factory();
})(globalThis, () => {
return 